<template>
	<c-dialog ref="dialog" width="700" @resolve="editHandle">
		<c-form ref="form" unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="标题" required>
				<c-input name="title" maxlength="500"></c-input>
			</c-form-item>
			<c-form-item label="客户端类型" required>
				<c-select name="type" :options="AD_TYPE" placeholder="请选择客户端类型"></c-select>
			</c-form-item>
			<c-form-item label="Banner图片" required tip="建议尺寸750x400像素">
				<c-upload-file name="image_url" type="image" size="1024" button="请选择图片" media></c-upload-file>
			</c-form-item>
			<c-form-item label="本地路径">
				<c-input name="local_url" maxlength="500"></c-input>
			</c-form-item>
			<c-form-item label="跳转地址">
				<c-input name="link_url" maxlength="500"></c-input>
			</c-form-item>
			<c-form-item label="第三方小程序AppId" required tip="跳转第三方小程序时必填">
				<c-input name="jump_app_id" maxlength="100" placeholder="如 wx1234567890abcdef"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {asyncMapState} from "../../store";

export default {
	data() {
		return {
			editState: false
		}
	},

	computed: {
		...asyncMapState(['AD_TYPE']),
	},

	methods: {
		/*********打开编辑框，初始化**********/
		open(data) {
			this.editState = false;
			this.$refs.form.clear();
			if (data) {
				this.editState = true;
				this.$refs.form.set(data);
			}
			// 填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑Banner' : '新增Banner'
			});
		},

		/*******新增、编辑提交处理方法********/
		editHandle(stop, next) {
			stop();
			this.$refs.form.submit({
				url: this.editState ? '/mall/banner/edit' : '/mall/banner/add',
				rule: {
					title: '请填写标题',
					type: '请选择客户端类型',
					image_url: '请上传Banner图片'
				},
				dataFormatter: data => {
					return data;
				},
				success: (data, res) => {
					next();
					if (this.editState) {
						this.$message({
							message: '编辑成功',
							type: 'success'
						});
					} else {
						this.$message({
							message: '新增成功',
							type: 'success'
						});
					}
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>
